"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const applyCommand_1 = require("../../applyCommand");
const ExecuteSelfEvaluateContent_1 = require("../../executeEvaluateContent/ExecuteSelfEvaluateContent");
const checkIfEnrolmentExists_1 = require("../../helpers/enrolment/checkIfEnrolmentExists");
const getContentType_1 = require("../../helpers/getContentType");
const getLibraryVersion_1 = require("../../helpers/getLibraryVersion");
const entity_1 = require("../../type/entity");
function ExecuteAssignMutation(command, user, content, childContents, states, enrolments, stateInteractions) {
    const events = [];
    let updatedStates = states;
    let updatedStateInteractions = stateInteractions;
    let updatedEnrolments = enrolments;
    const contentType = getContentType_1.getContentType(content);
    const applyPayload = applyCommand_1.applyCommand(command, user, content, childContents, updatedStates, enrolments, stateInteractions);
    events.push(...applyPayload.events);
    updatedStates = applyPayload.states;
    updatedEnrolments = applyPayload.enrolments;
    updatedStateInteractions = applyPayload.stateInteractions;
    // no evaluation for content types other than curriculum
    if (contentType === entity_1.ContentType.CURRICULUM) {
        const isAssigned = checkIfEnrolmentExists_1.checkIfNonDeletedEnrolmentExists(enrolments, content._id, user);
        if (!isAssigned) {
            const evaluationPayload = ExecuteSelfEvaluateContent_1.ExecuteSelfEvaluateContent(command, user, content, applyPayload.states);
            updatedStates = evaluationPayload.states;
            events.push(...evaluationPayload.events);
        }
    }
    command.libraryVersion = getLibraryVersion_1.getLibraryVersion();
    return {
        events,
        states: updatedStates,
        stateInteractions: updatedStateInteractions,
        enrolments: updatedEnrolments
    };
}
exports.ExecuteAssignMutation = ExecuteAssignMutation;
//# sourceMappingURL=index.js.map